'use strict';

var angularModule = angular.module('t2g.common.data-access.user-session', []);

module.exports = angularModule;

angularModule.factory('UserSessionResource', function($resource, settings) {
  var resourceUrl = settings.apiBase + '/api/user/:resource';

  var resource = $resource(
    resourceUrl,
    {},
    {
      ping: { method: 'GET', params: { resource: 'ping' } },
    },
  );

  return resource;
});

angularModule.factory('UserSessionDA', function(UserSession, UserSessionResource) {
  return {
    ping: ping,
  };

  function ping() {
    return UserSessionResource.ping().$promise.then(function(response) {
      return UserSession.qSet(response.session);
    });
  }
});



// WEBPACK FOOTER //
// ./src/app/common/data-access/userSession.js